import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import ArticleBody from '../ArticleBody';
import messages from '../../../messages';

const HowToPrepareForYourFirst = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage
        tagName="p"
        {...messages.howToPrepareForYourFirstBody}
      />
    </ArticleBody>
  </div>
);

HowToPrepareForYourFirst.propTypes = {};

export default HowToPrepareForYourFirst;
